import HeaderBalanceBlock from './HeaderBalanceBlock';

export default HeaderBalanceBlock;